import React, { useEffect, useState } from 'react';
import { AccountPageLayout } from 'pages/Account/components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Button, Link } from '@clariness/clarikit-react';
import { themes } from '@clariness/clarikit-tokens';
import { Services } from 'services';
import {
  InvestigatorNotificationUpdateDto,
  MultipleInvestigatorNotificationUpdateDto,
} from 'common/api';
import { Store } from 'store';
import { groupBy, mapValues } from 'lodash';
import { captureEventV2 } from 'utils/events/captureEvent';
import { Events } from '@clariness/tracking-event-runtime';
import { BoxLoader } from 'components/loaders';
// import { Environment } from 'global/environment';
// import { ShouldRender } from 'components/ShouldRender';
import { NewSiteAppointments } from './NewSiteAppointments';
import { NewReferralNotification } from './NewReferralNotification';
// import { NewPatientMarkedNotification } from './NewPatientMarkedNotification';

export type formData = {
  studyName: string;
  value: Array<InvestigatorNotificationUpdateDto>;
};

export const AccountNotification = () => {
  const { space } = themes.light;
  const intl = useIntl();
  const [formDataList, setFormDataList] = useState<Array<formData>>([]);
  const { user } = Store.useUser();
  const { refetch, data, isFetching } =
    Services.SiteEmployees.useGetInvestigatorStudies();
  const [isSaveEnabled, setIsSaveEnabled] = useState(true);
  const [notifications, setNotifications] =
    useState<MultipleInvestigatorNotificationUpdateDto>({
      investigatorNotificationUpdateDto: [],
    });

  useEffect(() => {
    if (data) {
      setNotifications({
        investigatorNotificationUpdateDto:
          data.investigatorNotificationUpdateDto,
      });
      const formDataList: Array<formData> = [];
      const groupBySite = mapValues(
        groupBy(data.investigatorNotificationUpdateDto, 'siteName')
      );
      for (const [key, value] of Object.entries(groupBySite)) {
        formDataList.push({
          studyName: key,
          value,
        });
      }
      setFormDataList(formDataList);
    }
  }, [isFetching, data]);

  const { updateNotification } =
    Services.SiteEmployees.useUpdateInvestigatorNotification({
      onSuccess: () => {
        refetch();
      },
    });
  return (
    <AccountPageLayout>
      <AccountPageLayout.Heading>
        <FormattedMessage
          id="is.account_notification.heading"
          defaultMessage="Notifications"
        />
      </AccountPageLayout.Heading>

      <AccountPageLayout.Paragraph>
        <FormattedMessage
          id="is.account_notification.main_paragraph"
          defaultMessage="By turning on notifications,
           you agree to receive email notifications in accordance with our {privacyPolicyLink}."
          values={{
            privacyPolicyLink: (
              <Box as="span" display="inline-block">
                <Link url={user?.privacyPolicyUrl ?? ''}>
                  <FormattedMessage
                    id="is.footer.link.privacy_policy"
                    defaultMessage="Privacy policy"
                  />
                </Link>
              </Box>
            ),
          }}
        />
      </AccountPageLayout.Paragraph>
      {isFetching ? (
        <BoxLoader />
      ) : (
        <AccountPageLayout.Form
          onSubmit={() => {
            captureEventV2(
              Events.InvestigatorService.InvestigatorClickedOnSaveInAccountNotificationPage(
                { InvestigatorID: user?.id ?? '' }
              )
            );
            updateNotification(notifications);
          }}
        >
          <Box display="flex" flexDirection="column" gap={space['space-16']}>
            <NewReferralNotification
              formDataList={formDataList}
              isFetching={isFetching}
              setIsSaveEnabled={setIsSaveEnabled}
              notifications={notifications}
              setNotifications={setNotifications}
            />
            <NewSiteAppointments
              formDataList={formDataList}
              isFetching={isFetching}
              setIsSaveEnabled={setIsSaveEnabled}
              notifications={notifications}
              setNotifications={setNotifications}
            />
            {/* disabing this functionality for now */}
            {/* <ShouldRender when={Environment.REACT_APP_MARK_PATIENT_ENABLED === 'true'}>
              <NewPatientMarkedNotification
                formDataList={formDataList}
                isFetching={isFetching}
                setIsSaveEnabled={setIsSaveEnabled}
                notifications={notifications}
                setNotifications={setNotifications}
              />
            </ShouldRender> */}
          </Box>

          <Box>
            <Button
              submit
              disabled={isSaveEnabled}
              data-test-id="notifications-submit-button"
            >
              {intl.formatMessage({
                id: 'is.account_language.save_language_button',
                defaultMessage: 'Save',
              })}
            </Button>
          </Box>
        </AccountPageLayout.Form>
      )}
    </AccountPageLayout>
  );
};
